import React from "react";
import { useIntl } from "react-intl";
import type { FC } from "react";

import { FavouritesDialog } from "../FavouritesDialog";
import { IDeleteFavouriteDialogProps } from "./DeleteFavouriteDialog.types";
import messages from "./DeleteFavouriteDialog.messages";

export const DeleteFavouriteDialog: FC<IDeleteFavouriteDialogProps> = (props) => {
  const { favouriteItemName, onDelete, ...otherProps } = props;
  const { formatMessage } = useIntl();

  return (
    <FavouritesDialog
      title={messages.title}
      contentText={formatMessage(messages.contentText, { favouriteItemName })}
      actions={[{ name: messages.remove, handleClick: onDelete }, { name: messages.cancel }]}
      alignActions="left"
      {...otherProps}
    />
  );
};
